module.exports = __webpack_public_path__ + "img/advantage2.70388aca.svg";